import type { Middleware, MiddlewareAPI, Dispatch } from 'redux';
import type { Action } from 'people/lib/shared';
import * as trace from 'owa-trace';

const reportError = (action: Action<{}>, error: Error): void => {
    const actionName = action.type;
    const message = `An exception occurred during dispatching of the action "${actionName}".
Please fix this immediately, even if you don't own this component.
This message is designed to be annoying so that the problem is addressed.`;

    // This shows an alert() popup in dev. In other environments it will be a console.error and is logged.
    trace.errorThatWillCauseAlert(message, error);
    // Add the actual error to console for extra debugging. As it could contain PII we do not log the error.
    console.error(error);
};

const middleware = (_store: MiddlewareAPI) => (next: Dispatch) => (action: Action<{}>) => {
    let result;
    try {
        result = next(action);
    } catch (e) {
        reportError(action, e);
    }

    return result;
};

export const exceptionHandlerMiddleware = middleware as Middleware;
